/**
 * @title fsamodal.js: Sub-module for Global pages
 * @description This module is used to display the fsa modal
 * @dependency 
 */
define(['dialog'], function(dialog) {	
	
	var fsamodal = {
			
		init : function() {
			this.attachExternalClass();
		},	 
    
	    attachExternalClass : function(){
			//$('.fsa-text').unbind().on('click' ,this.bind_external);
			$('body').on('click', '.fsa-text', this.bind_external);
		},
	
	   	bind_external : function(event) {
	   		fsamodal.createDialogBox(this.href);
	   		event.preventDefault();
	   	},
	    
	    createDialogBox : function(url) {
	      if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
	        dialog.createExtDialogBox({
	          title : messages.PDETAIL_FSA,
	          body : COSTCO.util.tmpl('tmpl_fsa_modal_v2',{}),
	          replaceFooter: COSTCO.util.tmpl('tmpl_fsa_footer_modal_v2',{}),
	          primary : messages.CLOSE,
	          primary_event: () => {
	            //COSTCO.dialog.close();
	          },
	          primary_button_style: "rounded"
	        });
	      } else {
	        dialog.createExtDialogBox({
	          title : messages.PDETAIL_FSA,
	          body : COSTCO.util.tmpl('tmpl_fsa_modal',{}),
	          primary : messages.CLOSE
	        });
	      }
	    }
		
	}//end fsamodal object

	// Expose fsamodal to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.fsamodal = fsamodal;
		
	return fsamodal;
    
});


// WEBPACK FOOTER //
// ./js/global/fsamodal.js